import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const UnfoldIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M12 5.83L15.17 9L16.58 7.59L12 3L7.41003 7.59L8.83003 9L12 5.83ZM12 18.17L8.83003 15L7.42003 16.41L12 21L16.59 16.41L15.17 15L12 18.17Z'
                fill='currentColor'
            />
        </>
    ),
})

UnfoldIcon.displayName = 'UnfoldIcon'
